import * as tslib_1 from "tslib";
import * as React from 'react';
import { Card, CardHeader, CardText } from 'material-ui';
import { avatar } from 'src/models/User';
import Badge from 'src/components/Badge';
import { cyan500 } from 'material-ui/styles/colors';
import { observer } from 'mobx-react';
var containerStyle = {
    display: 'flex',
    width: '100%',
    alignSelf: 'stretch'
};
var itemStyle = {
    margin: '1rem 0',
    maxWidth: '500px',
    borderRadius: '3px',
    boxShadow: 'none'
};
var MessageItem = /** @class */ (function (_super) {
    tslib_1.__extends(MessageItem, _super);
    function MessageItem(props) {
        return _super.call(this, props) || this;
    }
    MessageItem.prototype.componentDidMount = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var message;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        message = this.props.message;
                        if (!(!message.isReaded && !this.messages.isWrittenByMe(message))) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.messages.setReaded(message)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(MessageItem.prototype, "messages", {
        get: function () {
            return this.props.store.messages;
        },
        enumerable: true,
        configurable: true
    });
    MessageItem.prototype.render = function () {
        var _a = this.props, message = _a.message, store = _a.store;
        var user = store.getUserById(message.fromId);
        var userName = !!user ? user.name : store.userName;
        var incoming = message.fromId !== store.userId;
        var style = tslib_1.__assign({}, containerStyle, { flexDirection: incoming ? 'row' : 'row-reverse' });
        return (React.createElement("div", { key: message.id, style: style },
            React.createElement(Card, { style: itemStyle },
                React.createElement(CardHeader, { avatar: avatar(message.fromId), title: userName },
                    React.createElement("small", { className: "right text-muted" }, message.dateString)),
                React.createElement(CardText, null, message.content),
                !message.isReaded ? React.createElement(Badge, { color: cyan500, children: "Olvasatlan", styleOverride: { float: 'right', margin: '1rem' } }) : null)));
    };
    MessageItem = tslib_1.__decorate([
        observer
    ], MessageItem);
    return MessageItem;
}(React.Component));
export default MessageItem;



//////////////////
// WEBPACK FOOTER
// ./src/pages/messages/MessageItem.tsx
// module id = 801
// module chunks = 0